import Link from "next/link";
import { TbFileTypePdf } from "react-icons/tb";
export const PoweringCaseStudyCard = ({ caseStudy }) => {
  return (
    <Link href={`${caseStudy.file}`} className="webinars_list-item" target="_new">
      <span>{caseStudy.title}</span>
      <br />
      <span>
        <TbFileTypePdf />
      </span>
    </Link>
  );
};
